import { call, put, select, takeLatest } from 'typed-redux-saga'
import { RequestParams, ResponseCatalog } from 'Models'
import { errorHandler, loadersSlice, gridSlice } from 'Modules'
import { Deserialize } from 'cerialize'
import {
	agreementSelectors,
	AgreementModel,
	AgreementNS,
	AgreementsSlice,
	agreementApi,
} from 'Pages/admin'
import { routerActions } from 'connected-react-router'
import { FrontUrls } from 'Constants/FrontUrls'

export function* getAllAgreement(action: AgreementNS.getAllAgreement) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear, callback } = action.payload
		let requestParams
		if (params) {
			const { page, per_page, query, ...fields } = params
			requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		} else {
			requestParams = new RequestParams()
		}
		if (clear) {
			yield* put(AgreementsSlice.actions.clearAll())
		}
		let oldAgreements = new ResponseCatalog<AgreementModel>()
		if (!clear) {
			oldAgreements = yield* select(agreementSelectors.getAllAgreementCatalog)
		}
		const res = yield* call(agreementApi.getAll, requestParams)

		const agreements = new ResponseCatalog<AgreementModel>(res)
		const newAgreements = res.entries.map((item): AgreementModel => Deserialize(item))
		agreements.entries = [...oldAgreements.entries, ...newAgreements]
		yield* put(AgreementsSlice.actions.setAll(agreements))
		yield* put(AgreementsSlice.actions.setRequestParams(requestParams))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

export function* getAgreement(action: AgreementNS.getAgreement) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(agreementApi.getOne, action.payload.id)
		yield* put(AgreementsSlice.actions.setOne(Deserialize(res)))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* getAgreementByKey(action: AgreementNS.getAgreementByKey) {
	try {
		const { parentType, key } = action.payload
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(agreementApi.getOneByKey, parentType, key)
		yield* put(AgreementsSlice.actions.setOne(Deserialize(res)))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* updateAgreement(action: AgreementNS.updateAgreement) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(agreementApi.updateOne, action.payload)
		yield* put(AgreementsSlice.actions.setOne(Deserialize(res)))
		yield* put(AgreementsSlice.actions.setIsEdit(false))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* updateAgreementVersion(action: AgreementNS.updateAgreementVersion) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const res = yield* call(agreementApi.updateOneVersion, action.payload.data)
		yield* put(AgreementsSlice.actions.setIsEdit(false))
		yield* put(
			routerActions.push(
				FrontUrls.admin_panel.lead_edit.replace(':id', String(Deserialize(res)?.id))
			)
		)
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
		yield* call(errorHandler, error)
	}
}

export function* agreementSagas() {
	yield* takeLatest(AgreementsSlice.actions.getAll, getAllAgreement)
	yield* takeLatest(AgreementsSlice.actions.getOne, getAgreement)
	yield* takeLatest(AgreementsSlice.actions.getOneByKey, getAgreementByKey)
	yield* takeLatest(AgreementsSlice.actions.updateOne, updateAgreement)
	yield* takeLatest(AgreementsSlice.actions.updateOneVersion, updateAgreementVersion)
}
